export default __webpack_public_path__ + "static/knowledge-center-hero-108dd545bfca60ec2176a08dac4d6d6f.svg";